export default "__VITE_ASSET__CF8c3z5s__"